
// danh mục Customers
export const Action_GetDMCustomers = "Action_GetDMCustomers";
export const Action_GetDMCustomersSuccess = "Action_GetDMCustomersSuccess";

export const Action_GetCustomerByIdAndDebt = "Action_GetCustomerByIdAndDebt";
export const Action_GetCustomerByIdAndDebtSuccess = "Action_GetCustomerByIdAndDebtSuccess";
// save Customers
export const Action_SaveCustomers = "Action_SaveCustomers";
export const Action_SaveCustomersSuccess = "Action_SaveCustomersSuccess";
export const Action_SaveCustomersFailed = "Action_SaveCustomersFailed";
// danh mục nhom Customers
export const Action_GetDMNhomCustomers = "Action_GetDMNhomCustomers";
export const Action_GetDMNhomCustomersSuccess = "Action_GetDMNhomCustomersSuccess";
// delete Customers
export const Action_DeleteCustomers = "Action_DeleteCustomers";
export const Action_DeleteCustomersSuccess = "Action_DeleteCustomersSuccess";
export const Action_DeleteCustomersFailed = "Action_DeleteCustomersFailed";
